import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { useEffect } from 'react';
import chatStoreManager from '@/store/chat/manager';
import { useMemo } from 'react';
import { memo } from 'react';
import { useMessageContext } from '../chat-history/context';

const HtmlCardComponent = observer((props) => {
  const {
    className = '',
    htmlCode,
    codeInfo,
  } = props;

  const {
    msg_id : messageId,
  } = useMessageContext();

  const chatStore = chatStoreManager.current;
  const mcpStore = chatStore.mcpStore;

  const typingCode = mcpStore.isTypingHtml && messageId == chatStore.lastMessage.msg_id;
  const isCurrent = messageId == mcpStore.currentFileNode?.messageId;

  const handleUpdateNode = () => {
    mcpStore.setCurrentFileNode({
      content : htmlCode,
      type : "v3",
      title : codeInfo.title,
      messageId,
    });
  }

  const handleClick = () => {
    if(isCurrent){
      return;
    }
    handleUpdateNode();
  }

  useEffect(() => {
    if(isCurrent){
      handleUpdateNode();
    }
  }, [htmlCode]);

  const containerStyle = useMemo(() => {
    const style = {
      border: "1px solid rgba(0,0,0,.1)",
    }
    if(typingCode){
      style.background = "rgba(0,0,0,.03)";
    }
    if(isCurrent){
      style.border = "1px solid rgba(0,0,0,1)";
    }
    return style;
  }, [typingCode, isCurrent]);

  if(!codeInfo?.title){ 
    return null;
  }

  return (
    <div 
      className={`html-card w-2/3 mt-4px rounded-12px h-61px flex items-center cursor-pointer ${typingCode ? '' : 'hover:bg-black hover:bg-opacity-3'} ${className}`}
      // 在 markdown 内，使用 style 覆盖 markdown 样式
      style={containerStyle}
      onClick={handleClick}
      >
      {
        typingCode
        ? (
          <div className="size-32px ml-12px mr-8px rounded-8px bg-[#F4F4F4] flex items-center justify-center">
            <img className={`ani-rotate size-20px`} src="https://p3.ssl.qhimg.com/t11098f6bcdf41e7e312edb2121.png"></img>
          </div>
        )
        : (
          <img src="https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_link.png" className="size-32px ml-12px mr-8px rounded-8px" />
        )
      }
      <div className="mr-12px w-0 flex-grow">
        <div className="font-bold text-14px leading-20px truncate">
          {codeInfo.title}
        </div>
        <div className="text-black text-opacity-50 text-12px leading-17px truncate">
          点击打开预览
        </div>
      </div>
    </div>
  )
});
const HtmlCard = (HtmlCardComponent)
export default HtmlCard;